import React, { useState } from 'react'
import { useUsersUnderZoneHead } from '../../assets/api/useAdminApi'
import { DataGrid } from '@mui/x-data-grid'
import DataGridSkeleton from '../../shared/components/DataGridSkeleton'
import CustomPagination from '../../shared/utils/CustomPagination'
import { Typography } from '@mui/material'

export const CoordinatorListUnderZoneHead = ({ id }) => {
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 5 });
    const { data: userList, isLoading } = useUsersUnderZoneHead({ user_id: id })
    const userRow = userList?.users?.map((item, index) => ({
        sr_no: index + 1,
        ...item
    })) || []
    const UserColumn = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "firstname",
            headerName: "First Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "lastname",
            headerName: "Last Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "username",
            headerName: "User Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },


    ]

    return (
        <>

            {isLoading ? (
                <DataGridSkeleton rowsNum={10} />
            ) : (
                <DataGrid
                    rows={userRow}
                    columns={UserColumn}
                    pagination
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={[10]}
                    disableRowSelectionOnClick={true}
                    slots={{
                        pagination: () => (
                            <CustomPagination
                                paginationModel={paginationModel}
                                setPaginationModel={setPaginationModel}
                                totalRows={userRow?.length || 0}
                                pageSize={paginationModel.pageSize}
                            />
                        ),
                    }}
                />
            )}
        </>
    )
}
